import {Table} from 'antd';
import PropTypes from 'prop-types';
import {useState} from 'react';

const TableData = ({
  columns,
  dataSource,
  loading = false,
  rowKey = 'id',
  scroll = {x: 'max-content'},
  expandable,
  rowSelection,
  locale = {emptyText: 'No data found'},
  size = 'middle',
  pagination = true,
  rowClassName = 'transition-colors',
  ...rest
}) => {
  const [pageConfig, setPageConfig] = useState({
    current: 1,
    pageSize: 20,
  });

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      rowKey={rowKey}
      className={'border border-primary-50 rounded-lg'}
      size={size}
      scroll={scroll}
      locale={locale}
      expandable={expandable}
      rowSelection={rowSelection}
      rowClassName={rowClassName}
      pagination={
        pagination
          ? {
            current: pageConfig.current,
            pageSize: pageConfig.pageSize,
            total: dataSource?.length,

            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50', '100'],

            showQuickJumper: false,
            showLessItems: false,

            onChange: (page, pageSize) => {
              setPageConfig({
                current: page,
                pageSize,
              });
            },

            onShowSizeChange: (_, size) => {
              setPageConfig({
                current: 1,
                pageSize: size,
              });
            },

            ...(
              typeof pagination === 'object'
                ? pagination
                : {}
            ),
          }
          : false
      }
      {...rest}
    />
  );
};

TableData.propTypes = {
  columns: PropTypes.array.isRequired,
  dataSource: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  rowKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  scroll: PropTypes.object,
  expandable: PropTypes.object,
  rowSelection: PropTypes.object,
  locale: PropTypes.object,
  size: PropTypes.string,
  pagination: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.object,
  ]),
  rowClassName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]),
};

export default TableData;
